import React from 'react'
import { useSelector } from 'react-redux'
import { selectAuthData } from '../../store'

export const useAuth = () => {
  return useSelector(selectAuthData)
}
